import { createTheme } from "@mui/material";
const theme = createTheme({
  palette: {
    primary: {
      main: "#7DBFDD",
    },
    secondary: {
      main: "#820000",
    },
    info: {
      main: "#7DBFDD",
    },
    success: {
      main: "#00C9A5",
    },
    error: {
      main: "#E3597A",
    },
    warning: {
      main: "#F9F871",
    },
  },
});
export default theme;
